import type React from "react";
import { Link, useLocation } from "react-router-dom";

type NavItem =
  | { type: "route"; to: string; label: string }
  | { type: "anchor"; href: string; label: string };

const navItems: NavItem[] = [
  { type: "route", to: "/", label: "Home" },
  { type: "anchor", href: "#mission", label: "Mission" },
  { type: "anchor", href: "#impact", label: "Impact" },
  { type: "anchor", href: "#programs", label: "Programs" },
];

const DesktopMenu: React.FC = () => {
  const { pathname } = useLocation();
  const baseClasses =
    "inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium text-neutral-600 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300/60 focus-visible:ring-offset-1 focus-visible:ring-offset-white";

  return (
    <nav
      aria-label="Primary navigation"
      className="hidden items-center gap-3 md:flex"
    >
      <ul className="flex items-center gap-2">
        {navItems.map((item) => {
          if (item.type === "route") {
            const active =
              item.to === "/"
                ? pathname === "/"
                : pathname === item.to || pathname.startsWith(`${item.to}/`);
            return (
              <li key={item.label}>
                <Link
                  to={item.to}
                  aria-current={active ? "page" : undefined}
                  className={`${baseClasses} ${
                    active
                      ? "bg-primary-50 text-primary-700 shadow-sm"
                      : "hover:text-primary-700"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            );
          }

          return (
            <li key={item.label}>
              <a
                href={item.href}
                className={`${baseClasses} hover:text-primary-700`}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default DesktopMenu;
